import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'so'
})
export class StandingOutsharesPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {

  }

  transform(value: any, digits?: any): any {
    if (typeof value === 'number') {
      if (Math.floor(value / 1000000000)) {
        return this.decimalPipe.transform(value / 1000000000, digits) + 'bln';
      }
      if (Math.floor(value / 1000000)) {
        return this.decimalPipe.transform(value / 1000000, digits) + 'M';
      }
      return this.decimalPipe.transform(value, digits);
    }
    return '';
  }
}
